import { useTrackingUserParams } from 'modules/userTrackingParams';
import type { FC } from 'react';
import { createContext } from 'react';

interface StagContextData {
  isStag: boolean;
  isStagNDB: boolean;
}

export const StagContext = createContext<StagContextData>(null as any);

export const StagContextProvider: FC = ({ children }) => {
  const { isStag, isStagNDB } = useTrackingUserParams();

  return (
    <StagContext.Provider value={{ isStag, isStagNDB }}>
      {children}
    </StagContext.Provider>
  );
};
